import { render, staticRenderFns } from "./MediacontactView.vue?vue&type=template&id=11a61abf"
import script from "./MediacontactView.vue?vue&type=script&lang=js"
export * from "./MediacontactView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports